/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function EcommerceBanner() {
    return (
        <>
            <div className="banner">
                <img
                    src='../../assets/images/ecommerce.jpg'
                    alt="Virtual assistant helping with ecommerce business tasks"
                    title="Ecommerce Virtual Assistant Services by ConnectMyVA"
                    className="bannerImage"
                />
            </div>
        </>
    );
}

export default EcommerceBanner;
